import { useAuth } from "@/contexts/AuthContext";
import AdminDashboard from "@/components/dashboard/AdminDashboard";
import ProfessionalDashboard from "@/components/dashboard/ProfessionalDashboard";
import ReceptionDashboard from "@/components/dashboard/ReceptionDashboard";

/** Punto de entrada de /dashboard: cada rol ve una version distinta según
 * sus permisos (Admin: ejecutivo completo; Profesional: su propia actividad;
 * Recepcion: conteos operativos sin finanzas). */
export default function DashboardPage() {
  const { user } = useAuth();
  if (user?.role === "admin") return <AdminDashboard />;
  if (user?.role === "professional") return <ProfessionalDashboard />;
  return <ReceptionDashboard />;
}

